import React, { useCallback, useMemo } from 'react'
import { Box, Typography } from '@material-ui/core'
import _ from 'lodash'
import { RuleStepProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { handleProductToggle } from '../../MarketingCampaigns.promo.services'
import { ProductDiscountThresholdRuleState } from './types'
import {
	NumSpinner,
	ParamRow,
	ProductScopeSelector,
	RuleParamsPanel,
} from '../../CampaignModalSkeleton/components'

const WITH_BUTTON = false

export function ProductDiscountThresholdRuleStep({
	rule,
	setRule,
	description,
	sections,
}: RuleStepProps<ProductDiscountThresholdRuleState>) {
	const setPurchasedProducts = useCallback(
		(updater: any) => {
			setRule((r) => ({
				...r,
				purchasedProducts:
					typeof updater === 'function' ? updater(r.purchasedProducts) : updater,
			}))
		},
		[setRule],
	)

	const setFormValuesAdapter = useCallback(
		(updater: any) => {
			setRule((r) => {
				const patch = typeof updater === 'function' ? updater(r) : updater
				return { ...r, ...patch }
			})
		},
		[setRule],
	)

	const isDiscountError =
		rule.discount !== null && (rule.discount > 100 || rule.discount <= 0)
	const thresholdError = rule.threshold !== null && rule.threshold <= 0

	const selectedKeys = useMemo(
		() => rule.purchasedProducts.map((p) => p.productKey),
		[rule.purchasedProducts],
	)

	const disabledKeys = useMemo(
		() =>
			rule.disabledPurshasedProducts.map((item) => item.productKey),
		[rule.disabledPurshasedProducts],
	)

	if (!_.size(sections)) {
		return (
			<Box>
				{description}
				<Typography variant="body2" color="textSecondary" className="py-4">
					Aucun produit en commun n&apos;est disponible. Merci de sélectionner à nouveau les
					points de vente ciblés.
				</Typography>
			</Box>
		)
	}

	return (
		<Box>
			{description}
			<RuleParamsPanel>
				<ParamRow
					label="Réduction sur les produits sélectionnés"
					description="Pourcentage appliqué une fois le seuil de panier atteint"
					error={isDiscountError}
				>
					<NumSpinner
						value={rule.discount}
						onChange={(v) => setRule((prev) => ({ ...prev, discount: v }))}
						min={1}
						max={100}
						suffix="%"
						placeholder="20"
					/>
				</ParamRow>
				<ParamRow
					label="Seuil de déclenchement"
					description="Montant minimum du panier pour activer la remise"
					error={thresholdError}
					isLast
				>
					<NumSpinner
						value={rule.threshold}
						onChange={(v) => setRule((prev) => ({ ...prev, threshold: v }))}
						min={1}
						max={999999}
						suffix="€"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
			</RuleParamsPanel>
			<ProductScopeSelector
				sections={sections}
				selectedKeys={selectedKeys}
				disabledKeys={disabledKeys}
				showRankBadge
				maxListHeight={220}
				onToggle={(product, sectionId) =>
					handleProductToggle(
						product,
						sectionId,
						setPurchasedProducts,
						setFormValuesAdapter,
						WITH_BUTTON,
					)
				}
				instructions="Sélectionnez les produits éligibles à la promotion"
			/>
		</Box>
	)
}
